export default "__VITE_ASSET__DfqXUebi__"